// require('./jquery');
require('./bootstrap');
require('./jquery.form');
require('./jquery.validate.min');
require('./sweetalert.min');
require('./bootstrap-select.min');
// require('./persian.min');
require('./map/leaflet');
require('./owl.carousel.min');
!function () {
    var t = "undefined" != typeof module && module.exports, r = ["١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩", "٠"],
        n = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"], e = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];

    function i(t) {
        this._str = t
    }

    function s(t) {
        if (t) {
            for (var r = ["ي", "ك", "‍", "دِ", "بِ", "زِ", "ذِ", "ِشِ", "ِسِ", "ى", "ة"], n = ["ی", "ک", "", "د", "ب", "ز", "ذ", "ش", "س", "ی", "ه"], e = 0, i = r.length; e < i; e++) t = t.replace(new RegExp(r[e], "g"), n[e]);
            return this._str = t, this
        }
    }

    function u(t) {
        if (t) {
            for (var r = 0, i = e.length; r < i; r++) t = t.replace(new RegExp(n[r], "g"), e[r]);
            return this._str = t, this
        }
    }

    function o(t) {
        if (t) {
            t = t.toString();
            for (var e = 0, i = r.length; e < i; e++) t = t.replace(new RegExp(r[e], "g"), n[e]);
            return this._str = t, this
        }
    }

    function c(t) {
        if (t) {
            t = t.toString();
            for (var r = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"], n = ["۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹", "۰"], e = 0, i = r.length; e < i; e++) t = t.replace(new RegExp(r[e], "g"), n[e]);
            return this._str = t, this
        }
    }

    function f(t) {
        if (t) {
            for (var i = 0, s = e.length; i < s; i++) t = t.replace(new RegExp(n[i], "g"), e[i]).replace(new RegExp(r[i], "g"), e[i]);
            return this._str = t, this
        }
    }

    function h(t) {
        if (t) {
            for (var r = ""; r != t;) r = t, t = t.replace(/(http\S+?)\%20/g, "$1‌‌‌_‌‌‌");
            return t = (t = t.replace(/(http\S+)/g, function (t, r) {
                return decodeURI(r)
            })).replace(/\u200c\u200c\u200c_\u200c\u200c\u200c/g, "%20"), this._str = t, this
        }
    }

    function l(t) {
        if (t) {
            for (var r = ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح", "ج", "چ", "ش", "س", "ی", "ب", "ل", "ا", "ت", "ن", "م", "ک", "گ", "ظ", "ط", "ز", "ر", "ذ", "د", "پ", "و", "؟", "ئ"], n = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "[", "]", "a", "s", "d", "f", "g", "h", "j", "k", "l", ";", "'", "z", "x", "c", "v", "b", "n", "m", ",", "?", "m"], e = 0, i = r.length; e < i; e++) t = t.replace(new RegExp(r[e], "g"), n[e]);
            return this._str = t, this
        }
    }

    function a(t) {
        var r, n, e, i, s, u, o, c;
        return isFinite(t) ? ("string" != typeof t && (t = t.toString()), s = ["", "هزار", "میلیون", "میلیارد", "تریلیون", "کوادریلیون", "کویینتیلیون", "سکستیلیون"], i = {
            0: ["", "صد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"],
            1: ["", "ده", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"],
            2: ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"],
            two: ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"],
            zero: "صفر"
        }, valueParts = t.split("").reverse().join("").replace(/\d{3}(?=\d)/g, "$&,").split("").reverse().join("").split(",").map(function (t) {
            return Array(4 - t.length).join("0") + t
        }), "" === (u = (u = (u = function () {
            var t;
            for (e in t = [], valueParts) {
                c = valueParts[e];
                var u = (o = (o = function () {
                    var t, e, s;
                    for (s = [], n = t = 0, e = c.length; t < e; n = ++t) if (r = c[n], 1 === n && "1" === r) s.push(i.two[c[2]]); else {
                        if (2 === n && "1" === c[1] || "" === i[n][r]) continue;
                        s.push(i[n][r])
                    }
                    return s
                }()).join(" و ")) ? o + " " + s[valueParts.length - parseInt(e) - 1] : o;
                t.push(u)
            }
            return t
        }()).filter(function (t) {
            return "" !== t.trim()
        })).join(" و ").trim()) && (u = i.zero), this._str = u, this) : ""
    }

    function p(t) {
        var r;
        if (t) return r = /((\s\u0645\u06CC)+( )+([\u0600-\u06EF]{1,}){1,})/g, t = t.replace(new RegExp(r), "$2‌$4"), r = /(([\u0600-\u06EF]{1,})+( )+(ای|ایی|اند|ایم|اید|ام){1})/g, t = t.replace(new RegExp(r), "$2‌$4"), this._str = t, this
    }

    var g = function (t) {
        // if (!t || "" === t) throw new Error("Input is null or empty.");
        return new i(t)
    };
    g.version = "0.4.0", g.fn = i.prototype = {
        clone: function () {
            return g(this)
        }, value: function () {
            return this._str
        }, toString: function () {
            return this._str.toString()
        }, set: function (t) {
            return this._str = String(t), this
        }, arabicChar: function () {
            return s.call(this, this._str)
        }, persianNumber: function () {
            return u.call(this, this._str)
        }, arabicNumber: function () {
            return o.call(this, this._str)
        }, englishNumber: function () {
            return c.call(this, this._str)
        }, toEnglishNumber: function () {
            return f.call(this, this._str)
        }, fixURL: function () {
            return h.call(this, this._str)
        }, decodeURL: function () {
            return h.call(this, this._str)
        }, switchKey: function () {
            return l.call(this, this._str)
        }, digitsToWords: function () {
            return a.call(this, this._str)
        }, halfSpace: function () {
            return p.call(this, this._str)
        }
    }, t && (module.exports = g), "undefined" == typeof ender && (this.persianJs = g), "function" == typeof define && define.amd && define("persianJs", [], function () {
        return g
    })
}();
    function toEnglishNumber(strNum) {
        var pn = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
        var en = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
        var an = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
        var cache = strNum;
        for (var i = 0; i < 10; i++) {
            var regex_fa = new RegExp(pn[i], 'g');
            var regex_ar = new RegExp(an[i], 'g');
            cache = cache.replace(regex_fa, en[i]);
            cache = cache.replace(regex_ar, en[i]);
        }
        return cache;
    }



    $('select').on('change',function (){
        if ($(this).val() != ""){
            $('.'+$(this).attr('id')+'-has-error-from-validate').hide();
        }else{
            $('.'+$(this).attr('id')+'-has-error-from-validate').show();
        }
    });



    // When the user scrolls down 20px from the top of the document, show the button
    $(window).scroll(function(){scrollFunction()})

    function scrollFunction() {
        var showScrollPoint =$(window).height();
        var showScrollPoint2 =$(document).height();
        var showScrollPointFinal = showScrollPoint2 - showScrollPoint - 150;
        if (document.body.scrollTop > showScrollPointFinal || document.documentElement.scrollTop > showScrollPointFinal || document.documentElement.scrollTop > 200) {
            $('#goToTopBtn').show(500)
        } else {
            $('#goToTopBtn').hide(500)
        }
    }


    // show info under input fields on focus
    $('.input-has-info').on('focus',function (){
        if (!$(this).hasClass('input-has-error')){
            if ($(this).val().length > 2){
                $('#'+$(this).attr('id')+'-info').hide();
            }else{
                $('#'+$(this).attr('id')+'-info').show();
            }
        }
    });
    $('.input-has-info').on('keyup',function (e){
        if (!$(this).hasClass('input-has-error')){
            $('#'+$(this).attr('id')+'-info').show();
            if ($(this).val().length > 2){
                $('#'+$(this).attr('id')+'-info').hide();
            }
            if (e.keyCode === 13){
                $('#'+$(this).attr('id')+'-info').hide();
                var nextI = $("input").index(this)+1,
                    next=$("input").eq(nextI);
                next.focus();
            }
        }
    });
    $(document).on('keyup','.EnVal',function (e){
        var inputValToConvertEn=toEnglishNumber($(this).val());
        $(this).val(inputValToConvertEn);
        inputValToConvertEn= persianJs(inputValToConvertEn).switchKey();
        $(this).val(inputValToConvertEn);
        if (e.keyCode === 13) {
            $('#'+$(this).attr('id')+'-info').hide();
            var nextI = $("input").index(this)+1,
                next=$("input").eq(nextI);
            next.focus();
        }
    });
    $(document).on('focusout','.input-has-info',function (){
        $('#'+$(this).attr('id')+'-info').hide();
    });


    $(document).on('input','input',function (){
        var inputValToConvertEn=toEnglishNumber($(this).val());
        $(this).val(inputValToConvertEn);
        if ($(this).hasClass('input-has-error')){
            if ($(this).val().length > 0){
                $(this).removeClass('input-has-error');
                $(this).parent().find('.has-error').hide();
                $('span.'+$(this).attr('name')+'-has-error-from-validate').hide();
            }
        }
    });

    $(document).on('keyup','textarea',function (){
        var inputValToConvertEn=toEnglishNumber($(this).val());
        $(this).val(inputValToConvertEn);
        if ($(this).hasClass('input-has-error')){
            if ($(this).val().length > 2){
                $(this).removeClass('input-has-error');
                $('span.'+$(this).attr('name')+'-has-error-from-validate').hide();
            }
        }
    });
jQuery.fn.scrollToMyElement = function(elem, speed,margin_bottom=0) {
    var $this = jQuery(this);
    var $this_top = $this.offset().top;
    var $this_bottom = $this_top + $this.height();
    var $elem = jQuery(elem);
    var $elem_top = $elem.offset().top;
    var $elem_bottom = $elem_top + $elem.height() + margin_bottom;

    if ($elem_top > $this_top && $elem_bottom < $this_bottom) {
        // in view so don't do anything
        return;
    }
    var new_scroll_top;
    if ($elem_top < $this_top) {
        new_scroll_top = {scrollTop: $this.scrollTop() - $this_top + $elem_top};
    } else {
        new_scroll_top = {scrollTop: $elem_bottom - $this_bottom + $this.scrollTop()};
    }
    $this.animate(new_scroll_top, speed === undefined ? 100 : speed);
    return this;
};
String.prototype.nl2br = function()
{
    return this.replace(/\n/g, "<br />").trim();
};
String.prototype.br2nl = function()
{
    return this.replace("<br >", " ", "g").replace("<br>", " ", "g").trim();
};
String.prototype.removeNl = function()
{
    return this.replace(/\n/g, " ").trim();
};
require('./dragscroll');
require('./audio_record/WebAudioRecorder');


var MainWidthZommableImage=0;
var MainHeightZommableImage=0;
$(document).on('click','.showImageInModal',function (){
    $('#scaleImageModalRange').val('0');
    $('#showImageInModalFullScreenPhoto').attr('src',$(this).attr('src'));
    $('#showImageInModalFullScreenPhoto').css({'max-width':'100%'});
    $('#showImageInModalFullScreenPhoto').css({'max-height':'100%'});
    $('#showImageInModalFullScreenPhoto').css({'width':'unset'});
    $('#showImageInModalFullScreenPhoto').css({'height':'unset'});
    $('#showImageInModalFullScreenModal').modal('show');
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },200)
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },500)
    setTimeout(function (){
        MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
        MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
    },1000)


});
$( "#showImageInModalFullScreenModal" ).on('shown', function(){
    MainWidthZommableImage=$('#showImageInModalFullScreenPhoto').width();
    MainHeightZommableImage=$('#showImageInModalFullScreenPhoto').height();
});
$('#scaleImageModalRange').on('input',function (){
    chekScaleInImageModal();
});
function chekScaleInImageModal(){
    var showInModalImage_width=MainWidthZommableImage;
    var showInModalImage_height=MainHeightZommableImage;
    var ScaleVal= parseInt($('#scaleImageModalRange').val());
    showInModalImage_width=((showInModalImage_width * ScaleVal) / 100) + showInModalImage_width;
    $('#showImageInModalFullScreenPhoto').width(showInModalImage_width);
    $('#showImageInModalFullScreenPhoto').css({'max-width':showInModalImage_width});
    showInModalImage_height=((showInModalImage_height * ScaleVal) / 100) + showInModalImage_height;
    $('#showImageInModalFullScreenPhoto').height(showInModalImage_height);
    $('#showImageInModalFullScreenPhoto').css({'max-height':showInModalImage_height});
    var SIIMFSPEL=document.getElementById('showImageInModalFullScreenPhoto')
    var SIIMFSPELLeft = SIIMFSPEL.offsetLeft;
    if (SIIMFSPELLeft < 0){
        SIIMFSPEL.parentNode.scrollLeft = SIIMFSPELLeft / 2
    }
    $('#showImageInModalFullScreenBody').scrollTop((SIIMFSPEL.scrollHeight - $('#showImageInModalFullScreenBody').height()) / 2)
}
$('#showImageInModalFullScreenModal').on('wheel', function(e) {
    e.preventDefault();
    if ($('#showImageInModalFullScreenModal').is(':visible')){
        var delta = e.originalEvent.deltaY;
        var scaleImageModalRange= parseFloat($('#scaleImageModalRange').val());
        var step = parseFloat($('#scaleImageModalRange').attr('step')) * 10;
        if (delta > 0){
            // going down
            scaleImageModalRange = scaleImageModalRange - step ;
        }else{
            // going up
            scaleImageModalRange = scaleImageModalRange + step ;
        }
        $('#scaleImageModalRange').val(scaleImageModalRange);
        chekScaleInImageModal();
    }

});

$('#changePassType').on('click',function (){
    if ($('#password').prop('type') == 'password'){
        $('#password').prop("type", "text").attr("type", "text");
    }else{
        $('#password').prop("type", "password").attr("type", "password");
    }
});




// When the user clicks on the button, scroll to the top of the document
function topFunction() {
    $('html, body').animate({ scrollTop: 0 }, 'slow', function () {});
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

$('#goToTopBtn').on('click',function (){
    topFunction();
});



$(document).ready(function(){
    $('[data-show_title="tooltip"]').tooltip();
});



function isEnglish_lang(charCode){
    return (charCode >= 97 && charCode <= 122)
        || (charCode>=65 && charCode<=90);
}

function isPersian_lang(key){
    var p = /^[\u0600-\u06FF\s]+$/;
    return p.test(key) && key!=' ';
}
function string_to_slug_in_lang(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();
    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes
    return str;
}
// $('#slug').on("input",function (e) {
//     let thisEl=$(this).parent();
//     $(thisEl).find('span.has-error1').remove();
//     $(thisEl).find('.input-has-error1').removeClass('input-has-error1');
//     if(isPersian_lang(e.key)){
//         let i="slug";
//         let err="زبان صفحه کلید را به انگلیسی تغییر دهید ";
//         var el = $(document).find('[name="' + i + '"]');
//         el.addClass('input-has-error1');
//         el.after($('<span class="has-error1 ' + i + '-has-error-from-validate" style="color: red;">' + err + '</span>'));
//     }
//     var slug = string_to_slug_in_lang($('#slug').val().trim());
//     $('#slug').val(slug)
// });


$('.slug').on("keyup",function (e) {
    var $this=$(this);
    let thisEl=$(this).parent();
    var mystring = $($this).val().trim();

    mystring = mystring.replace('/','');
    mystring = mystring.replace('*','');
    mystring = mystring.replace('+','');
    mystring = mystring.replace('=','');
    mystring = mystring.replace('','');
    mystring = mystring.replace('&','');
    mystring = mystring.replace('#','');
    mystring = mystring.replace('%','');
    mystring = mystring.replace('@','');
    mystring = mystring.replace('!','');
    mystring = mystring.replace('`','');
    mystring = mystring.replace('(','');
    mystring = mystring.replace(')','');
    mystring = mystring.replace('?','');
    mystring = mystring.replace('"','');
    mystring = mystring.replace("'",'');
    mystring = mystring.replace(";",'');
    mystring = mystring.replace(".",'');
    mystring = mystring.replace("<",'');
    mystring = mystring.replace(">",'');
    var slug = string_to_slug_in_lang(mystring);
    $(this).val(slug);
    $(thisEl).find('span.has-error1').remove();
    $(thisEl).find('.input-has-error1').removeClass('input-has-error1');
    if(isPersian_lang(e.key)){
        let i=$($this).attr('name');
        let err="زبان صفحه کلید را به انگلیسی تغییر دهید ";
        var el = $(document).find('[name="' + i + '"]');
        el.addClass('input-has-error1');
        el.after($('<span class="has-error1 ' + i + '-has-error-from-validate" style="color: red;">' + err + '</span>'));
    }

});

(function() {
    $(document).on('shown.bs.modal', '.modal', function () {
        $(this).attr('aria-hidden', 'false');
    });

    $(document).on('hide.bs.modal', '.modal', function () {
        // اول از همه فوکوس رو از داخل مودال بردار
        if (document.activeElement && this.contains(document.activeElement)) {
            document.activeElement.blur();
        }
    });

    $(document).on('hidden.bs.modal', '.modal', function () {
        $(this).attr('aria-hidden', 'true');
    });
})();
